import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withConditionalFeatures } from '@americanexpress/conditional-features';
import { Surface } from '@americanexpress/dls-react';
import TravelCreditTabClose from './TravelCreditTabClose';
import { hasTravelCreditCenturionCardArtRule } from '../../constants/featureRulesConstants';
import MultipleTravelCredit from './MultipleTravelCredit';
import SingleTravelCredit from './SingleTravelCredit';
import { MODULE_NAME } from '../../constants/modules';
import { getTravelCredits } from '../../utils/membershipDataUtils';

const TravelCreditTab = ({
  isMobile,
  hasTravelCreditCenturionCardArt,
  membershipData,
}) => {
  const travelCreditsData = getTravelCredits(membershipData);
  const hasMultipleCredit = travelCreditsData.length > 1;

  return (
    <Surface variant="base" className="height-full" data-testid={`${MODULE_NAME}-travel-credit-tab`}>
      {!isMobile && <TravelCreditTabClose />}
      <section className="border-lr-sm-down pad-2-lr-sm-down pad-2-tb-sm-down pad-3-lr-md-up pad-3-b-md-up">
        {hasMultipleCredit ? (
          <MultipleTravelCredit
            travelCreditsData={travelCreditsData}
            membershipData={membershipData}
            hasTravelCreditCenturionCardArt={hasTravelCreditCenturionCardArt}
          />
        ) : (
          <SingleTravelCredit
            travelCreditsData={travelCreditsData}
            membershipData={membershipData}
            hasTravelCreditCenturionCardArt={hasTravelCreditCenturionCardArt}
          />
        )}
      </section>
    </Surface>
  );
};

TravelCreditTab.propTypes = {
  isMobile: PropTypes.bool,
  hasTravelCreditCenturionCardArt: PropTypes.bool.isRequired,
  membershipData: PropTypes.shape({
    displayAccountNumber: PropTypes.string,
    cardArtCdnLink: PropTypes.string,
    travelCredit: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      marketingText: PropTypes.string,
      callToActionText: PropTypes.string,
      landingPage: PropTypes.string,
      expiry: PropTypes.string,
    })),
  }),
};

TravelCreditTab.defaultProps = {
  isMobile: false,
  membershipData: {},
};

export const mapFeaturesToProps = {
  hasTravelCreditCenturionCardArt: hasTravelCreditCenturionCardArtRule,
};

const hocChain = compose(
  withConditionalFeatures({ mapFeaturesToProps })
);

export { TravelCreditTab as TestableTravelCreditTab };

export default hocChain(TravelCreditTab);
